/**
 * #2218: whether the person put away the notice that a new enterprise was just made for them. Kept for the browser
 * session, per enterprise, so it stays put away when the screen is opened again or the page reloads, and a later
 * founding (another enterprise) is told about afresh.
 */
const KEY_PREFIX = 'os:founded-notice-dismissed:'

/** Whether the notice about `enterpriseId` was put away in this browser session. False when storage is unavailable. */
export function foundedNoticeDismissed(enterpriseId: string): boolean {
    try {
        return sessionStorage.getItem(KEY_PREFIX + enterpriseId) === '1'
    } catch {
        return false
    }
}

/** Puts the notice about `enterpriseId` away for the rest of this browser session. */
export function dismissFoundedNotice(enterpriseId: string): void {
    try {
        sessionStorage.setItem(KEY_PREFIX + enterpriseId, '1')
    } catch {
        // With browser storage unavailable the notice is still hidden now, and shows again on the next visit.
    }
}
